document.addEventListener('turbo:load', function() {
  const popup = document.getElementById('roleRequirementsPopup');
  const openButton = document.getElementById('openRoleRequirementsPopup');
  const closeButtons = document.querySelectorAll('.popup-close, .popup-cancel');
  const saveButton = document.querySelector('.popup-save');
  const roleRadios = document.querySelectorAll("input[name='roleType']");

  if (!popup || !openButton) return;

  openButton.addEventListener('click', function(e) {
    e.preventDefault();
    popup.style.display = 'flex';
  });

  closeButtons.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      popup.style.display = 'none';
      resetForm();
    });
  });

  popup.addEventListener('click', function(e) {
    if (e.target === this) {
      this.style.display = 'none';
      resetForm();
    }
  });

  roleRadios.forEach(function(radio) {
    radio.addEventListener('change', handleRoleTypeChange);
  });

  if (saveButton) {
    saveButton.addEventListener('click', handleSave);
  }

  function handleRoleTypeChange(e) {
    const roleType = e.target.value;

    document.querySelectorAll('.conditional-section').forEach(function(section) {
      section.style.display = 'none';
    });

    // Show selected section
    const sectionMap = {
      'software': 'softwareRoleSection',
      'data': 'dataRoleSection',
      'other': 'otherRoleSection'
    };

    const sectionId = sectionMap[roleType];
    if (sectionId) {
      const section = document.getElementById(sectionId);
      if (section) section.style.display = 'block';
    }

    updateRadioStyles(e.target);
  }

  function updateRadioStyles(selectedRadio) {
    document.querySelectorAll('.custom-radio').forEach(function(radio) {
      radio.style.borderColor = '#eae5db';
      radio.style.background = 'white';
      radio.innerHTML = '';
    });

    if (selectedRadio) {
      const customRadio = selectedRadio.parentElement.querySelector('.custom-radio');
      if (customRadio) {
        customRadio.style.borderColor = '#1f8a5b';
        customRadio.style.background = '#1f8a5b';
        customRadio.innerHTML = '<span style="width: 8px; height: 8px; background: white; border-radius: 50%; display: block;"></span>';
      }
    }
  }

  function handleSave() {
    const roleTypeRadio = document.querySelector("input[name='roleType']:checked");
    if (!roleTypeRadio) {
      alert("Please select a role type.");
      return;
    }

    const roleType = roleTypeRadio.value;

    // Clear existing requirements to replace instead of add
    if (typeof aiReviewFilters !== 'undefined' && aiReviewFilters.role_requirements) {
      aiReviewFilters.role_requirements = [];
    }

    // Map role types to display names
    const roleTypeNames = {
      'software': 'Software Engineering',
      'data': 'Data & Analytics',
      'other': 'Other Role'
    };

    if (roleType === 'software') {
      const techSelect = document.getElementById('softwareRoleSelect');
      if (!techSelect || !techSelect.value) {
        alert("Please select a technology/role.");
        return;
      }
      const techItem = {
        type: roleType,
        display: techSelect.options[techSelect.selectedIndex].text
      };
      aiReviewFilters.role_requirements.push(techItem);
    } else if (roleType === 'data') {
      const dataSelect = document.getElementById('dataRoleSelect');
      if (!dataSelect || !dataSelect.value) {
        alert("Please select a data role.");
        return;
      }
      const dataItem = {
        type: roleType,
        display: dataSelect.options[dataSelect.selectedIndex].text
      };
      aiReviewFilters.role_requirements.push(dataItem);
    } else if (roleType === 'other') {
      const otherText = document.getElementById('otherRoleText');
      const description = otherText ? otherText.value.trim() : '';
      if (!description) {
        alert("Please enter a description.");
        return;
      }
      const otherItem = {
        type: roleType,
        display: description
      };
      aiReviewFilters.role_requirements.push(otherItem);
    }

    if (typeof aiReviewFilters !== 'undefined' && aiReviewFilters.role_requirements) {
      if (typeof renderAddedItems === 'function') {
        renderAddedItems();
      }
    }

    popup.style.display = 'none';
    resetForm();
  }

  function resetForm() {
    roleRadios.forEach(function(radio) {
      radio.checked = false;
    });

    document.querySelectorAll('.conditional-section').forEach(function(section) {
      section.style.display = 'none';
    });

    const softwareSelect = document.getElementById('softwareRoleSelect');
    const dataSelect = document.getElementById('dataRoleSelect');
    const otherText = document.getElementById('otherRoleText');

    if (softwareSelect) softwareSelect.value = '';
    if (dataSelect) dataSelect.value = '';
    if (otherText) otherText.value = '';

    updateRadioStyles(null);
  }
});
